import { ReactNode } from 'react';

import { dynamicStyling, parseSize } from 'styles';
import { OrString } from 'types';

import { cssToClasses, Gap } from './styles';

type LengthValue = string | number;

/**
 * Warning;
 *
 * Working version. Could and probably will change
 */

interface GridProps {
  className?: string;

  children: ReactNode;

  /**
   * Define the set amount of columns or pass in an array if you want
   * specific control over each column
   */
  cols?: number | 'auto-fill' | 'auto-fit' | LengthValue[];

  rows?: number | LengthValue[];

  /**
   * If using `auto-fill` | `auto-fit` this will be treated
   * as the minWidth possible for each col
   */
  colWidth?: number | OrString<'fr'>;
  rowHeight?: number | OrString<'fr'>;

  gap?: Gap;
  rowGap?: Gap;
  columnGap?: Gap;

  fullWidth?: boolean;
  fullHeight?: boolean;
}

function resolveRowColValue(refCount: GridProps['cols'], refSize: GridProps['colWidth']) {
  if (Array.isArray(refCount)) return refCount.join(' ');

  const isKeyWordColumn = Number.isNaN(Number(refCount));

  if (isKeyWordColumn) return `repeat(${refCount}, minmax(${parseSize(refSize!)}, 1fr))`;

  if (refSize === 'fr') return `repeat(${refCount}, 1fr)`;

  const size = refSize ? parseSize(refSize) : 'minmax(0, 1fr)';

  return `repeat(${refCount}, ${size})`;
}

export function Grid({
  children,
  className,

  cols = 1,
  colWidth = 0,

  fullHeight,
  fullWidth,

  rows,
  rowHeight,

  gap = '4',
  columnGap,
  rowGap,
}: GridProps) {
  return (
    <div
      {...dynamicStyling({
        gridColumns: resolveRowColValue(cols, colWidth),

        gridRows: rows ? resolveRowColValue(rows as 1, rowHeight) : undefined,

        className: [
          'grid',
          { 'w-full': fullWidth, 'h-full': fullHeight },

          cssToClasses.gap[gap],
          !!columnGap && cssToClasses.gap[columnGap],
          !!rowGap && cssToClasses.gap[rowGap],

          className,
        ],
      })}
    >
      {children}
    </div>
  );
}
